/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ActiveMemberCardActionsAddAdminDialogMutationVariables = {
    userId: string;
};
export type ActiveMemberCardActionsAddAdminDialogMutationResponse = {
    readonly makeAdminMember: {
        readonly success: boolean;
    };
};
export type ActiveMemberCardActionsAddAdminDialogMutation = {
    readonly response: ActiveMemberCardActionsAddAdminDialogMutationResponse;
    readonly variables: ActiveMemberCardActionsAddAdminDialogMutationVariables;
};



/*
mutation ActiveMemberCardActionsAddAdminDialogMutation(
  $userId: ID!
) {
  makeAdminMember(input: {userId: $userId}) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "MakeAdminMemberPayload",
    "kind": "LinkedField",
    "name": "makeAdminMember",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActiveMemberCardActionsAddAdminDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActiveMemberCardActionsAddAdminDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3775e9dc6a5a00dca030dafb4625dd6f",
    "id": null,
    "metadata": {},
    "name": "ActiveMemberCardActionsAddAdminDialogMutation",
    "operationKind": "mutation",
    "text": "mutation ActiveMemberCardActionsAddAdminDialogMutation(\n  $userId: ID!\n) {\n  makeAdminMember(input: {userId: $userId}) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '7a58c45f2fd95aab775c5bfaf527f3d8';
export default node;
